exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\naside.pcoded-slider.ng-sidebar {\r\n    top: 56px;\r\n}\r\n\r\n.slimscroll-wrapper, .scroll-window {\r\n    width: 100% !important;\r\n}\r\n\r\n.userlist-box.show {\r\n    display: -webkit-box;\r\n}\r\n\r\n.userlist-box.hide {\r\n    display: none;\r\n}\r\n.page-footer{\r\n\r\n    background-color: #fff;\r\n    height:40px;\r\n\r\n}\r\n\r\n.img-fluid {\r\n    max-width: 100%;\r\n    height: 50px !important;\r\n   \r\n}\r\n\r\n@media only screen and (max-width: 770px) {\r\n    .img-fluid {\r\n        max-width: 100%;\r\n        height: 50px;\r\n        margin-top:-10px;\r\n    }\r\n  }\r\n\r\n\r\n  @media (max-width:600px){\r\n#marg{\r\n margin-top: -56px !important;\r\n\r\n}\r\n\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/app/layouts/admin/admin-layout.component.css
// module id = ../../../../../src/app/layouts/admin/admin-layout.component.css
// module chunks = main